
import { Component, Vue, Prop } from "vue-property-decorator";
import { pendoMixin } from "@/utils/mixins";
import vSelect from "vue-select";
import { SessionVariablesHelper } from "@/utils/helpers";

const sessionVariables = new SessionVariablesHelper();

@Component({
  components: {
    vSelect,
  },

  mixins: [
    pendoMixin
  ]
})
export default class Platform extends Vue {
  private isMobile: boolean = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  private platformSelected(platformObj) {
    if(platformObj) {
      this.$('#vSelect >>> .vs__open-indicator').css({ display: "none" });
      this.$auth.login({
        method: "put",
        url: "auth/platform/" + platformObj.id_platform,
        redirect: "",
        fetchUser: true,
        params: {},
        success: (response: any) => {
          // @ts-ignore
          this.initPendo()

          sessionVariables.update()

          this.$router.push({ path: "/dashboard" });
        },
        error: (result: any) => {
          console.log(result);
        }
      });

    } else {
      this.$('#vSelect >>> .vs__open-indicator').css({ display: "block" });
    }
  }

}
